module.exports = "/_next/static/media/Video4.7570c2d4ce1b276998620fefb3c0292e.mp4";